import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const CampaignPage = lazy(() => import('../../container/campaign/CampaignPage'));

function CampaignRoutes() {
  const { path } = useRouteMatch();

  return (
    <Switch>
      <Route path={`${path}`} component={CampaignPage} />
    </Switch>
  );
}

export default CampaignRoutes;
